export default "__VITE_ASSET__dfd044cd__"